import {
  Button, Loading, SearchBar, Typography,
} from "@kitbird/core";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import BBLogo from "../../../assets/icons/logogram_bb.png";
import {
  CardContent,
  PageCard,
  PageWrapper,
  TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { StickyTable } from "../../../components/Table/Table.style";
import UserAccountTable from "./components/UserAccountTable";
import ModalFormUserAccount from "./components/ModalFormUserAccount/ModalFormUserAccount";
import BaseLoading from "../../../components/Loading/BaseLoading";
import { useUserAccount } from "./useUserAccount";

const UserAccount = () => {
  const {
    isFetching,
    isFetchingNextPage,
    isLoading,
    isModalAddOpen,
    lastElementRef,
    onDeleteClick,
    onInputSearch,
    onSubmit,
    toggleModalAddOpen,
    userAccountList,
  } = useUserAccount();

  if (isLoading) return <BaseLoading />;
  return (
    <>
      <PageWrapper>
        <HeaderText>
          <Typography level={3} fontWeight="medium">
            Master user account
          </Typography>
        </HeaderText>
        <PageCard>
          <CardContent>
            <TitleContent>
              <img src={BBLogo} width={40} alt="" />
              <Typography level={4} fontWeight="medium">
                Daftar user account
              </Typography>
            </TitleContent>
            <ActionSection>
              <SearchBar
                onInputSearch={onInputSearch}
                hasReset
                placeholder="Cari data"
              />
              <Button
                leftIcon={<PlusIcon />}
                onClick={() => toggleModalAddOpen(true)}
              >
                Tambah data
              </Button>
            </ActionSection>
            <StickyTable>
              {isFetching && !isFetchingNextPage
                ? <Loading variant="line" />
                : <UserAccountTable
                  onActionClick={{
                    delete: (data) => onDeleteClick(data),
                  }}
                  dataSource={userAccountList
                    ? userAccountList.pages.flatMap((page) => page.user) : []}
                  footer={
                    <>
                      <tfoot ref={lastElementRef} style={{ height: 5, width: "100%" }} />
                      {isFetchingNextPage && <Loading variant="circular" />}
                    </>
                  }
                />
              }
            </StickyTable>
          </CardContent>
        </PageCard>
      </PageWrapper>
      <ModalFormUserAccount
        isOpen={isModalAddOpen}
        toggleOpen={toggleModalAddOpen}
        onSubmit={onSubmit}
      />
    </>
  );
};

export default UserAccount;
